import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { catchError, of, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { Me } from '../models';

// Single source of truth for authorization in the UI: the signed-in user's roles + effective
// permissions, computed by the backend (GET /central/me) from the role->permission map. Gate menu
// items / routes off has(...) so the UI can't drift from what the API enforces.
@Injectable({ providedIn: 'root' })
export class PermissionsService {
    private readonly http = inject(HttpClient);
    private readonly auth = inject(AuthService);

    private readonly me = toSignal(
        toObservable(this.auth.isAuthenticated).pipe(
            switchMap((authenticated) =>
                authenticated
                    ? this.http.get<Me>(`${environment.apiBaseUrl}/central/me`).pipe(catchError(() => of(null)))
                    : of(null)
            )
        ),
        { initialValue: null as Me | null }
    );

    readonly roles = computed(() => this.me()?.roles ?? []);
    readonly permissions = computed(() => this.me()?.permissions ?? []);

    has(permission: string): boolean {
        return this.permissions().includes(permission);
    }
}
